import React from 'react';

import { ServiceProductData } from '../../../../shared/types/graphql-types';

import styles from './store-services.scss';

interface StoreServicesProps {
  servicesList: Array<ServiceProductData>;
}

export default function StoreServices(props: StoreServicesProps) {
  const { servicesList } = props;

  return (
    <ul className={styles['service-list']} data-testid={'mainlst'}>
      {servicesList?.map((service, idx) => (
        <li
          className={styles['service-list-item']}
          data-testid={`lst-${idx}`}
          key={`ss-${idx}`}
        >
          {service.name}
        </li>
      ))}
    </ul>
  );
}
